import React from 'react'
import { cn } from 'design-system'

import Dots from 'src/components/generics/loading/dots'

const Button = ({
  component = 'button',
  className,
  children,
  disabled = false,
  error = false,
  secondary = false,
  small = false,
  tiny = false,
  color,
  bypass = false,
  plain = false,
  circle = false,
  loading = false,
  ref,
  ...buttonProps
}) => {
  const ButtonComponent = component

  return (
    <ButtonComponent
      className={cn(
        {
          'yd-button': !bypass,
          'yd-button--disabled': !!disabled,
          'yd-button--secondary': !!secondary,
          'yd-button--small': !!small,
          'yd-button--tiny': !!tiny,
          'yd-button--circle': !!circle,
          'yd-button--plain': !!plain,
          'yd-button--error': !!error,
          [`yd-button--${color}`]: !!color
        },
        className
      )}
      {...{ ...buttonProps, disabled }}
      ref={ref}>
      {loading ? <Dots /> : children}
    </ButtonComponent>
  )
}

export default Button
